<template>
  <div class="footer-container">
    <div class="tips-container">
      <span v-for="(tip, i) in tips" :key="i" @click="handleClickTip(tip)">{{ tip }}</span>
    </div>
    <div class="input-container">
      <textarea v-model="content" @keydown.enter="handleEnter" :disabled="disabled" placeholder="有问题可以直接向我提问哟" />
    </div>
    <div class="btn-container">
      <el-button :disabled="isSendBtnDisable" @click="handleSend" type="primary" round>
        发送
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessageBoxFooter",
  props: {
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      content: null,
      tips: [
        '帮我设计生成一张橙色沙发',
        '帮我设计生成一个美式风格的客厅'
      ]
    };
  },
  computed: {
    isSendBtnDisable() {
      return this.disabled || !this.content || !this.content.trim().length;
    },
  },
  methods: {
    handleSend() {
      if (this.isSendBtnDisable) return;

      this.$emit("send", this.content);
      this.content = null;
    },
    handleEnter(e) {
      if (e.altKey) {
        this.content = (this.content || "") + "\n";
      } else {
        e.preventDefault();
        this.handleSend();
      }
    },
    handleClickTip(tip) {
      this.content = tip
      this.handleSend()
    }
  },
};
</script>

<style lang="scss" scoped>
.footer-container {
  padding: 20px 0;
  height: 100%;
  box-sizing: border-box;

  .input-container {
    margin-top: 20px;
    textarea {
      height: 120px;
      width: 100%;
      display: block;
      padding: 5px 15px;
      line-height: 1.5;
      box-sizing: border-box;
      width: 100%;
      font-size: 16px;
      color: #606266;
      background-color: #fff;
      background-image: none;
      border: none;
      border-radius: 4px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      resize: none;
      padding: 0;

      &:focus-visible,
      &:focus {
        outline: none;
      }
    }
  }

  .tips-container {
    font-size: 12px;
    margin-top: 3px;
    span {
      padding: 7px;
      border-radius: 3px;
      background: #F5F8FB;
      cursor: pointer;
      margin-right: 10px;
      font-weight: 600;
    }
  }

  .btn-container {
    text-align: right;
    margin-top: 15px;

    .el-button {
      background: #235daa;
      &.is-disabled {
        background: #6494d2;
      }
    }
  }
}
</style>